import { Component } from '@angular/core';

import { RegistrationStepDirective } from '../registration-step.directive';

@Component({
  selector: 'om-virtual-care-confirmation-step',
  styleUrls: ['../../../shared/form-input.scss'],
  templateUrl: './virtual-care-confirmation-step.component.html',
})
export class VirtualCareConfirmationStepComponent extends RegistrationStepDirective {
  constructor() {
    super();
  }

  onSubmit() {
    this.submitting = true;
    this.submit.emit();
  }
}
